const e=["ctrlKey","metaKey","altKey","shiftKey"],t=t=>e.some((e=>e in t&&t[e]));export{t as isModifiedClickEvent};
//# sourceMappingURL=is-modified-click-event.js.map
